var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"locationItem",on:{"click":function($event){return _vm.$emit('handleClick', _vm.image, _vm.index)}}},[_c('div',{staticClass:"locationItem__image",style:({backgroundImage: ("url(" + _vm.image + ")")})}),_vm._v(" "),_c('h3',{staticClass:"locationItem__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a1f816","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocationItem.vue
// module id = null
// module chunks = 